import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../Contexts/AuthContext";
import { CaretIcon } from "./CaretIcon";
import { userMenuItems } from "../helpers";
import { NavLink } from "react-router-dom";

// Component for the logged-in user menu (desktop - remains a dropdown)
const LoggedInDropdown = () => {
    // FIX: Using 'logout' from AuthContext, as defined in the context provider
    const { token, user, signOut, setIsLoginModal } = useContext(AuthContext);
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);

    const navButtons = [
        {
            name: "Login",
            onClick: () => {
                setIsLoginModal(true)
            }
        },
        // { name: "Register", path: "/register" },
    ];


    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [ref]);

    const userName = user?.name || "";
    if (token) {
        return (
            <div className="relative inline-block text-left font-inter" ref={ref}>
                <div>
                    <button
                        type="button"
                        className={`inline-flex justify-between items-center gap-1.5 px-4 py-2 text-base lg:text-lg font-medium text-${isOpen ? 'neutral-950' : 'white'} bg-${isOpen ? 'white' : 'transparent'} border border-white rounded-[10px] hover:bg-white hover:!text-gray-600 focus:!text-gray-600 transition-colors`}
                        onClick={() => setIsOpen(!isOpen)}
                        aria-expanded={isOpen}
                        aria-haspopup="true"
                    >
                        <span className='max-w-40 line-clamp-1 text-left'>Hello, {userName || "Guest User"}</span>
                        <CaretIcon isOpen={isOpen} className="w-4 h-4" />
                    </button>
                </div>

                {isOpen && (
                    <div className="absolute right-0 mt-2 min-w-48 origin-top-right rounded-md shadow-lg bg-[#171A26] bg-gradient-radial border border-white/20 ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                        <div className="py-2 px-2 space-y-1">
                            {userMenuItems(user?.role).map((item) => (
                                item.isLink ? (
                                    <NavLink
                                        key={item.name}
                                        to={item.path}
                                        onClick={() => setIsOpen(false)}
                                        className={({ isActive }) =>
                                            `block px-4 py-2 text-sm text-white hover:!text-gray-400 hover:bg-white/10 rounded-md font-semibold ${isActive ? 'bg-white/5' : ''}`
                                        }
                                    >
                                        {item.name}
                                    </NavLink>
                                ) : (
                                    <button
                                        key={item.name}
                                        onClick={() => {
                                            signOut();
                                            setIsOpen(false);
                                        }}
                                        className="w-full text-left block px-4 py-2 text-sm text-white hover:!text-gray-400 hover:bg-white/10 rounded-md font-semibold"
                                    >
                                        {item.name}
                                    </button>
                                )
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    } else {
        return (
            <>
                {
                    navButtons.map((buttonDetails, index) =>
                    (
                        <button
                            key={index}
                            {...!!buttonDetails?.onClick && { onClick: buttonDetails?.onClick }}
                            className="font-inter px-5 py-2 lg:px-7 lg:py-2 rounded-[10px] border border-white text-white text-base font-medium lg:text-lg hover:bg-white hover:!text-neutral-950 focus:bg-white focus:!text-neutral-950 hover:font-semibold transform hover:shadow-[0px_0px_5px_5px_rgba(171,198,248,0.5)] focus:shadow-[0px_0px_5px_5px_rgba(171,198,248,0.5)] transition-shadow"
                        >
                            {buttonDetails.name}
                        </button>
                    ))
                }
            </>
        )
    }
};

export { LoggedInDropdown }